module.exports = __webpack_public_path__ + "static/media/add room.b3b0dfd4.svg";